import React, { Component } from "react";
import ReactConfirmAlert from "react-confirm-alert"; // Import
import classes from "./styles.css";
import axios from "axios";
import { connect } from "react-redux";
import * as actions from "../../../store/actions/index";
import { backendBaseUri } from "../../../uri";

class DraftForms extends Component {
    state = {
        showDialog: false,
        itemToDelete: null,
    };

    onToggleDialog(id) {
        this.setState({
            showDialog: !this.state.showDialog,
        });
        if (id) {
            this.setState({
                itemToDelete: id,
            });
        } else {
            return;
        }
    }

    deletePatientForm(id) {
        const { itemToDelete } = this.state;
        this.setState({
            showDialog: !this.state.showDialog,
        });

        let formIdToDelete = this.props.forms[itemToDelete]._id;

        axios
            .delete(`${backendBaseUri}/drafts/${formIdToDelete}`, {
                headers: {
                    "x-auth": localStorage.getItem("token"),
                },
            })
            .then((res) => {
                this.props.onFormListLoad(res.data.drafts);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    render() {
        let formName = this.props.forms.map((form, index) => {
            return (
                <div key={index}>
                    <li>
                        <i
                            onClick={(e) => this.onToggleDialog(e.target.id)}
                            id={index}
                            className="fa fa-times"
                            style={{ color: "red", marginRight: 10 }}
                        />
                        <span
                            id={index}
                            onClick={(e) => this.props.handleClickDraftedConsent(e.target.id)}
                        >
                            {form.draftedFormName}
                        </span>
                    </li>
                </div>
            );
        });
        return (
            <div className={classes.List}>
                <ul>{formName}</ul>
                {this.state.showDialog ? (
                    <div className={classes.alertPopup}>
                        <ReactConfirmAlert
                            title="Are you sure to delete this patient's consent form?"
                            message=""
                            confirmLabel="Yes"
                            cancelLabel="No"
                            onConfirm={() => this.deletePatientForm()}
                            onCancel={() => this.onToggleDialog()}
                        />
                    </div>
                ) : (
                    <div />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        consentForms: state.formBuilder.consentForms,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onFormListLoad: (forms) => dispatch(actions.fetchForms(forms)),
        onDisplayForm: (form) => dispatch(actions.fetchForm(form)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DraftForms);



// WEBPACK FOOTER //
// ./src/components/Forms/DraftForms/DraftForms.js